import { useQuery } from "@tanstack/react-query";
import { API_BASE, handleResponse, parseResponse } from "./common";
import { fetchWithInterceptor } from "./client";
import { EntityRegistrySchema, type EntityRegistry } from "./types";

/**
 * The entity registry. `includeHidden` is for *naming* surfaces only — rule
 * summaries have to be able to name a retired entity, or a rule that is broken
 * precisely because something was hidden renders it as a raw ULID, which is
 * unreadable exactly when the user most needs to read it. Pickers must keep
 * using the default (visible-only) registry.
 */
export const useEntityRegistry = (includeHidden = false) => {
  return useQuery<EntityRegistry>({
    queryKey: ["registry", { includeHidden }],
    queryFn: async () => {
      const query = includeHidden ? "?includeHidden=true" : "";
      const response = await fetchWithInterceptor(
        `${API_BASE}/registry${query}`,
      );
      await handleResponse(response);
      return parseResponse(
        EntityRegistrySchema,
        await response.json(),
        "GET /registry",
      );
    },
  });
};
